import { useEffect } from "react";
// logo
import appLogo from "../../assets/svg/appLogo.svg";

export const SplashScreen = ({ setLoading, hide }) => {

    useEffect(() => {
        const hasVisited = sessionStorage.getItem("hasVisited");

        if (hasVisited) {
            setLoading(false); // Skip splash screen
        } else {
            sessionStorage.setItem("hasVisited", "true"); // Set flag
            setTimeout(() => {
                setLoading(false);
            }, 4500); // Show splash for 2s
        }
    }, []);

    return (
        <div className={`splash-container ${hide ? "hidden" : ""} flex items-center flex-col gap-3 justify-center h-screen bg-[#01b4ae] text-white text-xl`}>
            <img src={appLogo} alt="App Logo" className="w-40 h-40 animate-bounce" />
        </div>
    );
};